import createHistory from 'history/createBrowserHistory'
import * as React from 'react'
import { hydrate } from 'react-dom'
import * as Loadable from 'react-loadable'

import { measure } from '../common/utils/performance'
import { clientFinishedLoading } from '../common/actions/common'
import { reportPerformanceMetrics } from '../common/analytics'
import { siteNames } from '../common/constants/siteList'
import configureStore from '../common/store/configureStore'

import {
  manualGALinker,
  handleGAOptedOutEvent
} from '../common/utils/cookiebotGAHelper'
import { handleExperimentOptedOutEvent } from '../common/utils/cookiebotExperimentHelper'
import {
  deferLoadGoogleAnalytics,
  deferLoadGTMScript
} from '../common/utils/deferScriptLoader'
import domLoaded from '../common/utils/domLoaded'
import affiliateRecorder from '../common/utils/affiliateRecorder'
import patchDOMForGoogleTranslate from '../common/utils/patchDOMForGoogleTranslate'
import { getCurrentSiteFromDomain } from '../common/utils/sites'
import App from './app'

import '../assets/stylesheets/style.css'
import './index.css'

patchDOMForGoogleTranslate()
deferLoadGoogleAnalytics()
deferLoadGTMScript()
manualGALinker()
handleGAOptedOutEvent()
handleExperimentOptedOutEvent()

affiliateRecorder(window.location, document.referrer)

try {
  measure()
    .then(reportPerformanceMetrics)
    .catch(() => {})
} catch (e) {}

// this only runs on initial hydrating
const initialState = (window as any).INITIAL_STATE
delete (window as any).INITIAL_STATE

const history = createHistory()
const store = configureStore(initialState, history)

async function main() {
  await Loadable.preloadReady()
  await domLoaded()

  hydrate(
    <App store={store} history={history} />,
    document.querySelector('#react-view'),
    () => {
      store.dispatch(clientFinishedLoading())
    }
  )
}

const site = getCurrentSiteFromDomain(window.location.hostname)
const shouldLoadReact = site && siteNames.includes(site)
if (shouldLoadReact) {
  main()
}
